/*
 * export from ngx-lib/core/portal
 */
export * from './public-api';
